import { BookingDataDetails } from '../cartridges.models';
import { BookingState } from '../enums/booking-state';
import { Page, PageFilterOption } from 'data-model';

export const MOCK_BOOKING_REQUESTS: Page<BookingDataDetails> = {
  result: [
    {
      id: '641dba34a268057048bcbce1',
      cartridgeVariantId: '6405e29544e9fd436c21be4f',
      cartridgeVariantName: 'Leistung-Prototyp Variante 1',
      bookingDate: '2023-03-12T08:01:21.241Z',
      lastModifiedAt: '2023-03-16T08:01:21.241Z',
      organizationId: '641c06deb8d32907ac9f80bf',
      organizationName: 'Super Testing GmbH',
      bookingState: BookingState.PENDING,
      initiator: {
        organization: {
          masterKin: 'TEST-KIN-1234',
        },
      },
    } as BookingDataDetails,
    {
      id: '641dba34a268057048bcbce2',
      cartridgeVariantId: '6412bb3a4c3c8038ed7d2003',
      cartridgeVariantName: 'Leistung-Prototyp Variante 2',
      bookingDate: '2023-03-14T08:01:21.241Z',
      lastModifiedAt: '2023-03-15T08:01:21.241Z',
      organizationId: '641d7fa110b23dfed3d172c2',
      organizationName: 'Local Development Inc.',
      bookingState: BookingState.BOOKED,
      initiator: {
        organization: {},
      },
    } as BookingDataDetails,
  ],
  hasNext: false,
  pageIndex: 0,
  pageSize: 25,
  totalCount: 2,
  filterValues: {
    cartridgeIdToName: [
      {
        key: 'cartridgeVariantId',
        label: 'Cartridge variant name',
      },
      {
        key: 'cartridgeVariantId2',
      } as PageFilterOption,
    ],
  },
};
